// extracted by mini-css-extract-plugin
export var active = "_ch-7";
export var container = "_ch-0";
export var evenWidth = "_ch-4";
export var large = "_ch-5";
export var outlet = "_ch-8";
export var slide = "_ch-2";
export var small = "_ch-6";
export var tab = "_ch-3";
export var tabs = "_ch-1";